import { useState } from "react";
import type { MapQueryComparator } from "./mapQuery.ts";

/**
 * MapQueryBar.tsx's overlay state. `thresholdInput` is the raw text of the
 * number input, not yet parsed, so a user can type "-" or "1." mid-edit
 * without it being clobbered back to "" by a failed `Number()` parse on
 * every keystroke; App.tsx parses it where the filter actually runs.
 */
export function useMapQuery() {
  const [open, setOpen] = useState(false);
  const [attribute, setAttribute] = useState<string | null>(null);
  const [comparator, setComparator] = useState<MapQueryComparator>(">");
  const [thresholdInput, setThresholdInput] = useState("0");

  function toggle() {
    setOpen((o) => !o);
  }

  function close() {
    setOpen(false);
  }

  return {
    open,
    attribute,
    comparator,
    thresholdInput,
    setAttribute,
    setComparator,
    setThresholdInput,
    toggle,
    close,
  };
}
